export var EntityActionType;
(function (EntityActionType) {
    EntityActionType[EntityActionType["Silverlight"] = 0] = "Silverlight";
    EntityActionType[EntityActionType["WebForm"] = 2] = "WebForm";
    EntityActionType[EntityActionType["CLI"] = 3] = "CLI";
    EntityActionType[EntityActionType["WindowsFormsOffline"] = 4] = "WindowsFormsOffline";
    EntityActionType[EntityActionType["Mvc"] = 5] = "Mvc";
    EntityActionType[EntityActionType["MvcMobile"] = 6] = "MvcMobile";
    EntityActionType[EntityActionType["MvcTablet"] = 7] = "MvcTablet";
})(EntityActionType || (EntityActionType = {}));
;
